import { Divider } from "@msuite/ui/divider";
import { useTranslation } from "@msuite/ui/localization";
import type { SubstitutionPlanSummaryItemSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { getFullName } from "@msuite/utils/users";

/** Props Interface */
interface SubstitutionGeneralSummaryItemProps {
	item: SubstitutionPlanSummaryItemSchema;
}

export function SubstitutionGeneralSummaryItem({ item }: SubstitutionGeneralSummaryItemProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-2 py-3 first:pt-0 last:pb-0">
			<div className="justify-between h-stack">
				<p className="font-medium">{guardString(item.projectName)}</p>
				<p className="tabular-nums label">{guardString(item.projectNumber)}</p>
			</div>
			<div className="gap-4 h-stack items-start">
				<div className="flex-1 v-stack gap-1">
					<p className="label">{t("substitutions.substitutions")}</p>
					{!item.substitutions.length && <p>{guardString(null)}</p>}
					{item.substitutions.map((substitution, index) => (
						<p key={substitution.id}>
							{index + 1}. {getFullName(substitution)}
						</p>
					))}
				</div>
				<div className="flex-1 v-stack gap-1">
					<p className="label">{t("contacts.contacts")}</p>
					{!item.contacts.length && <p>{guardString(null)}</p>}
					{item.contacts.map((contact, index) => (
						<p key={contact.id}>
							{index + 1}. {getFullName(contact)}
						</p>
					))}
				</div>
			</div>
			{item.quickNote && (
				<>
					<Divider />
					<p className="label whitespace-pre-wrap">{item.quickNote}</p>
				</>
			)}
		</div>
	);
}
